import React from 'react';

const FeeInfo = () => {
  return <div>FeeInfo</div>;
};

export default FeeInfo;
